import { render, staticRenderFns } from "./TariffEdit.vue?vue&type=template&id=cc3efcc8"
import script from "./TariffEdit.vue?vue&type=script&lang=js"
export * from "./TariffEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports